import { createContext, useRef, useState } from "react";
import PropTypes from 'prop-types';
export const VideoContext = createContext()


export default function VideoProvider(props) {
    const { sequences, children } = props;
    const videoRef = useRef();
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);

    const play = () => {
        setPlaying(true);
    }

    const pause = () => {
        setPlaying(false)
    }

    const changePlaying = () => {
        setPlaying(!playing)
    }

    return (
        <VideoContext.Provider value={{
            ref: videoRef, playing, setPlaying, progress,
            setProgress, play, pause, changePlaying, sequences,
        }}>
            {children}
        </VideoContext.Provider>
    )
}

VideoProvider.propTypes = {
    sequences: PropTypes.array,
    children: PropTypes.node
}